module.exports = __webpack_public_path__ + "static/img/autumn_banner.d81c5529.jpg";